const BUILT_IN_DRILL_TEMPLATES = [
  {
    id: 'ski_turn_initiation_001_garland_turns',
    title: 'Garland turns',
    description: 'Repeat early turn starts without crossing the whole slope to focus on the release.',
    sport: 'skiing',
    discipline: 'all-mountain',
    level: ['beginner', 'intermediate'],
    topic: 'turn initiation',
    commonError: 'holds on to the old turn too long',
    correctionCue: 'guide the skis into the new direction earlier',
    focusAreas: ['release', 'transition', 'steering'],
    tags: ['release', 'transition', 'steering'],
    steps: [
      'Start on easy terrain.',
      'Release the old edge gradually.',
      'Guide the skis into the new arc without twisting the upper body.',
    ],
    visibility: 'org',
    createdBy: 'sas_system',
    orgId: 'sas_global',
    relatedSkillIds: [{ skillId: 'sas_ski_turn_initiation_timing', treeId: 'sas_ski_tree_v1' }],
    sourceType: 'sas_kb',
    sourceLabel: 'SAS Draft KB',
  },
  {
    id: 'ski_turn_initiation_001_sideslip_release',
    title: 'Sideslip to edge release',
    description: 'Practice flattening and re-engaging the skis to feel the start of a new turn.',
    sport: 'skiing',
    discipline: 'all-mountain',
    level: ['beginner', 'intermediate'],
    topic: 'turn initiation',
    commonError: 'starts the new turn too abruptly',
    correctionCue: 'flatten first, then let the edges engage progressively',
    focusAreas: ['release', 'edging'],
    tags: ['release', 'edging'],
    steps: [
      'Sideslip on mellow terrain.',
      'Flatten the skis to release the edge.',
      'Re-engage the new edge gradually.',
    ],
    visibility: 'org',
    createdBy: 'sas_system',
    orgId: 'sas_global',
    relatedSkillIds: [
      { skillId: 'sas_ski_turn_initiation_timing', treeId: 'sas_ski_tree_v1' },
      { skillId: 'sas_ski_edge_engagement_timing', treeId: 'sas_ski_tree_v1' },
    ],
    sourceType: 'sas_kb',
    sourceLabel: 'SAS Draft KB',
  },
  {
    id: 'ski_edging_basics_001_j_tracks',
    title: 'J-track edging',
    description: 'Make shallow J-shaped tracks to feel how gradual edge angle changes shape the skis.',
    sport: 'skiing',
    discipline: 'all-mountain',
    level: ['beginner', 'intermediate'],
    topic: 'edging basics',
    commonError: 'engages the edges too late or too abruptly',
    correctionCue: 'tip the skis progressively and feel the edge build',
    focusAreas: ['edging', 'balance'],
    tags: ['edging', 'balance'],
    steps: [
      'Start in a shallow traverse.',
      'Increase edge angle slowly until a J-shaped track forms.',
      'Repeat on both sides.',
    ],
    visibility: 'org',
    createdBy: 'sas_system',
    orgId: 'sas_global',
    relatedSkillIds: [
      { skillId: 'sas_ski_edge_engagement_timing', treeId: 'sas_ski_tree_v1' },
      { skillId: 'sas_ski_pressure_control', treeId: 'sas_ski_tree_v1' },
    ],
    sourceType: 'sas_kb',
    sourceLabel: 'SAS Draft KB',
  },
  {
    id: 'ski_balance_stance_001_hands_forward',
    title: 'Hands-forward stance laps',
    description: 'Ski easy terrain focusing on a tall stance, soft ankles, and quiet hands forward.',
    sport: 'skiing',
    discipline: 'all-mountain',
    level: ['beginner'],
    topic: 'balance and stance',
    commonError: 'drops the hands and folds at the waist',
    correctionCue: 'stay tall and keep the hands calmly in view',
    focusAreas: ['stance', 'balance'],
    tags: ['stance', 'balance'],
    steps: [
      'Choose easy terrain.',
      'Ski with quiet hands forward.',
      'Check that the ankles stay soft while the torso remains tall.',
    ],
    visibility: 'org',
    createdBy: 'sas_system',
    orgId: 'sas_global',
    relatedSkillIds: [{ skillId: 'sas_ski_balanced_stance', treeId: 'sas_ski_tree_v1' }],
    sourceType: 'sas_kb',
    sourceLabel: 'SAS Draft KB',
  },
  {
    id: 'snowboard_alignment_001_flat_base',
    title: 'Flat-base glide checks',
    description: 'Glide on mellow terrain to feel a centered mobile stance, stacked alignment, and calmer edge preparation.',
    sport: 'snowboarding',
    discipline: 'all-mountain',
    level: ['beginner'],
    topic: 'stance and alignment',
    commonError: 'uses counter-rotation instead of staying centered and aligned over the board',
    correctionCue: 'stay centered and stacked while the board glides underneath you',
    focusAreas: ['centered stance', 'stacked alignment', 'centered mobile position', 'edge change'],
    tags: ['centered stance', 'stacked alignment', 'centered mobile position', 'quieter upper body'],
    steps: [
      'Glide on a flat base on mellow terrain.',
      'Keep shoulders quiet and centered over the board.',
      'Repeat with attention on even pressure under both feet and a calm edge change setup.',
    ],
    visibility: 'org',
    createdBy: 'sas_system',
    orgId: 'sas_global',
    relatedSkillIds: [],
    sourceType: 'sas_kb',
    sourceLabel: 'SAS Draft KB',
  },
  {
    id: 'snowboard_heel_toe_001_garlands',
    title: 'Heel-to-toe patience garlands',
    description: 'Work repeated edge changes on mellow terrain to smooth out initiation and stop the rider from rushing the new edge.',
    sport: 'snowboarding',
    discipline: 'all-mountain',
    level: ['beginner', 'intermediate'],
    topic: 'heel-side and toe-side initiation',
    commonError: 'shows heel/toe asymmetry and rushes the transition into the new edge',
    correctionCue: 'use a patient transition and move smoothly across the board before asking for the new edge',
    focusAreas: ['patient transition', 'edge change', 'turn initiation', 'stronger edge commitment'],
    tags: ['patient transition', 'heel/toe asymmetry', 'late transition', 'edge change', 'stronger edge commitment'],
    steps: [
      'Traverse on one edge.',
      'Flatten the board gently.',
      'Roll onto the new edge without rushing the shoulders.',
      'Let the board change edge before steering harder into the new turn.',
    ],
    visibility: 'org',
    createdBy: 'sas_system',
    orgId: 'sas_global',
    relatedSkillIds: [],
    sourceType: 'sas_kb',
    sourceLabel: 'SAS Draft KB',
  },
  {
    id: 'snowboard_rotation_001_quiet_upper_body',
    title: 'Quiet upper body traverses',
    description: 'Traverse both ways keeping shoulders stable so the board changes direction from the lower body instead of abrupt upper-body steering.',
    sport: 'snowboarding',
    discipline: 'all-mountain',
    level: ['intermediate'],
    topic: 'rotation control',
    commonError: 'uses counter-rotation and weak lower-body steering to start every turn',
    correctionCue: 'keep a quieter upper body and let the legs steer the board',
    focusAreas: ['quieter upper body', 'lower-body steering', 'stacked alignment', 'upper-lower body separation'],
    tags: ['counter-rotation', 'quieter upper body', 'lower-body steering', 'upper-lower body separation'],
    steps: [
      'Traverse heel side and toe side.',
      'Keep shoulders aligned with the board.',
      'Initiate direction changes from the lower body.',
    ],
    visibility: 'org',
    createdBy: 'sas_system',
    orgId: 'sas_global',
    relatedSkillIds: [],
    sourceType: 'sas_kb',
    sourceLabel: 'SAS Draft KB',
  },
  {
    id: 'snowboard_control_001_transition_patience',
    title: 'Transition patience laps',
    description: 'Ride mellow linked turns focusing on allowing the board to move underneath you before adding more steering effort.',
    sport: 'snowboarding',
    discipline: 'all-mountain',
    level: ['intermediate'],
    topic: 'transition timing',
    commonError: 'shows late transition and loses calm board flow between turns',
    correctionCue: 'use a patient transition and let the board come through the fall line cleanly',
    focusAreas: ['patient transition', 'transition timing', 'calm board flow', 'edge change'],
    tags: ['patient transition', 'late transition', 'calm board flow', 'edge change', 'transition timing'],
    steps: [
      'Ride easy blue terrain with medium-radius turns.',
      'Count a calm rhythm through the edge change before adding steering.',
      'Check whether the board keeps moving instead of stalling between turns.',
    ],
    visibility: 'org',
    createdBy: 'sas_system',
    orgId: 'sas_global',
    relatedSkillIds: [],
    sourceType: 'sas_kb',
    sourceLabel: 'SAS Draft KB',
  },
  {
    id: 'snowboard_pressure_001_centered_corridor',
    title: 'Centered corridor turns',
    description: 'Use a narrow corridor or visual lane to keep the rider centered and reduce aft, abrupt steering into the turn.',
    sport: 'snowboarding',
    discipline: 'all-mountain',
    level: ['intermediate'],
    topic: 'pressure management',
    commonError: 'shows back-foot dominance and inconsistent pressure control through the transition',
    correctionCue: 'stay centered over the board and use smoother pressure management from edge to edge',
    focusAreas: ['centered stance', 'smoother pressure management', 'pressure management', 'board performance'],
    tags: ['back-foot dominance', 'centered stance', 'smoother pressure management', 'speed control issue', 'board performance'],
    steps: [
      'Set a narrow visual corridor on mellow terrain.',
      'Ride linked turns while staying centered over both feet.',
      'Notice whether the board tracks more cleanly without chatter or wash.',
    ],
    visibility: 'org',
    createdBy: 'sas_system',
    orgId: 'sas_global',
    relatedSkillIds: [],
    sourceType: 'sas_kb',
    sourceLabel: 'SAS Draft KB',
  },
];

export function normalizeSportName(sport) {
  const value = (sport || '').toLowerCase();

  if (value.startsWith('ski')) {
    return 'skiing';
  }

  if (value.startsWith('snow')) {
    return 'snowboarding';
  }

  return value;
}

function toArray(value) {
  if (Array.isArray(value)) {
    return value.filter(Boolean);
  }

  if (typeof value === 'string' && value.trim()) {
    return [value.trim()];
  }

  return [];
}

const SNOWBOARD_TOPIC_ALIASES = {
  'heel side and toe side initiation': 'heel-side and toe-side initiation',
  'heel/toe initiation': 'heel-side and toe-side initiation',
  'board steering': 'rotation control',
};

const SNOWBOARD_TERM_ALIASES = {
  'upper body': 'quieter upper body',
  'quiet upper body': 'quieter upper body',
  'quiet shoulders': 'quieter upper body',
  'counter rotation': 'counter-rotation',
  'board steering': 'lower-body steering',
  'steer with the legs': 'lower-body steering',
  'steer from the lower body': 'lower-body steering',
  'separation': 'upper-lower body separation',
  'centered': 'centered stance',
  'stance': 'centered stance',
  'alignment': 'stacked alignment',
  'fore-aft': 'back-foot dominance',
  'aft stance': 'back-foot dominance',
  'edge readiness': 'stronger edge commitment',
  'transition': 'transition timing',
  'loss of momentum': 'calm board flow',
  'pressure': 'pressure management',
  'speed control': 'speed control issue',
};

function normalizeSnowboardTopic(topic) {
  const value = String(topic || '').trim().toLowerCase();
  return SNOWBOARD_TOPIC_ALIASES[value] || String(topic || '').trim();
}

function normalizeSnowboardTerm(term) {
  const value = String(term || '').trim();
  if (!value) return '';
  return SNOWBOARD_TERM_ALIASES[value.toLowerCase()] || value;
}

function normalizeSnowboardTerms(values = []) {
  const seen = new Set();
  return toArray(values)
    .map(normalizeSnowboardTerm)
    .filter((value) => {
      const key = value.toLowerCase();
      if (!value || seen.has(key)) {
        return false;
      }
      seen.add(key);
      return true;
    });
}

function normalizeSkillReference(item) {
  if (!item) {
    return null;
  }

  if (typeof item === 'string' && item.trim()) {
    return {
      skillId: item.trim(),
      treeId: 'sas_ski_tree_v1',
    };
  }

  if (typeof item === 'object' && item.skillId) {
    return {
      skillId: String(item.skillId).trim(),
      treeId: String(item.treeId || 'sas_ski_tree_v1').trim(),
    };
  }

  return null;
}

export function normalizeSkillReferences(value) {
  const seen = new Set();

  return toArray(value)
    .map(normalizeSkillReference)
    .filter((item) => {
      if (!item?.skillId) {
        return false;
      }

      const key = `${item.treeId}::${item.skillId}`;
      if (seen.has(key)) {
        return false;
      }
      seen.add(key);
      return true;
    });
}

export function getCanonicalOrgId(userData) {
  return (
    userData?.orgId ||
    userData?.schoolId ||
    userData?.organizationId ||
    userData?.academyId ||
    ''
  );
}

export function normalizeDrillTemplate(template, currentUserOrgId = '') {
  if (!template) {
    return null;
  }

  const sourceType = template.sourceType || template.source || 'instructor_custom';
  const visibility = template.visibility === 'school' ? 'org' : (template.visibility || 'private');
  const orgId = template.orgId || template.organizationId || getCanonicalOrgId(template) || currentUserOrgId || '';
  const createdBy = template.createdBy || template.ownerId || '';
  const tags = toArray(template.tags);
  const focusAreas = toArray(template.focusAreas).length > 0
    ? toArray(template.focusAreas)
    : tags;
  const level = toArray(template.level);
  const steps = Array.isArray(template.steps)
    ? template.steps.filter(Boolean)
    : Array.isArray(template.drills)
      ? template.drills.map((item) => {
          if (typeof item === 'string') {
            return item;
          }
          return [item.title, item.description].filter(Boolean).join(': ');
        }).filter(Boolean)
      : [];
  const relatedSkillIds = normalizeSkillReferences(template.relatedSkillIds);
  const sport = normalizeSportName(template.sport || '');
  const normalizedTopic = sport === 'snowboarding'
    ? normalizeSnowboardTopic(template.topic || '')
    : (template.topic || '');
  const normalizedTags = sport === 'snowboarding'
    ? normalizeSnowboardTerms(tags)
    : tags;
  const normalizedFocusAreas = sport === 'snowboarding'
    ? normalizeSnowboardTerms(focusAreas)
    : focusAreas;
  const accessVisibility =
    visibility === 'org'
      ? 'organization'
      : visibility === 'platform'
        ? 'platform'
        : visibility === 'assigned_only'
          ? 'assigned_only'
          : 'private';
  const ownerType =
    template.ownerType ||
    (accessVisibility === 'platform'
      ? 'platform'
      : orgId && accessVisibility === 'organization'
        ? 'organization'
        : 'instructor');
  const ownerId =
    template.ownerId ||
    (ownerType === 'platform'
      ? 'platform'
      : ownerType === 'organization'
        ? orgId
        : createdBy);

  return {
    id: template.id || '',
    title: template.title || 'Untitled Drill',
    summary:
      template.summary ||
      template.description ||
      template.plainLanguageDescription ||
      '',
    description:
      template.description ||
      template.plainLanguageDescription ||
      '',
    sport,
    discipline: template.discipline || '',
    level,
    topic: normalizedTopic,
    commonError:
      template.commonError ||
      toArray(template.commonIssues)[0] ||
      '',
    correctionCue:
      template.correctionCue ||
      toArray(template.correctionCues)[0] ||
      '',
    focusAreas: normalizedFocusAreas,
    tags: normalizedTags,
    steps,
    relatedSkillIds,
    visibility,
    accessVisibility,
    ownerType,
    ownerId,
    accessTier: template.accessTier || 'free',
    contentPackId: template.contentPackId || '',
    assignedUserIds: Array.isArray(template.assignedUserIds) ? template.assignedUserIds.filter(Boolean) : [],
    createdBy,
    orgId,
    organizationId: orgId,
    sourceType,
    sourceLabel:
      template.sourceLabel ||
      (sourceType === 'sas_kb'
        ? 'SAS Draft KB'
        : visibility === 'org'
          ? 'School Library'
          : 'Instructor Library'),
    createdAt: template.createdAt || null,
    updatedAt: template.updatedAt || null,
  };
}

export function normalizeDrillTemplates(list, currentUserOrgId = '') {
  return (list || [])
    .map((item) => normalizeDrillTemplate(item, currentUserOrgId))
    .filter(Boolean);
}

export function getTemplateSearchText(template) {
  return [
    template.title,
    template.description,
    template.topic,
    template.commonError,
    template.correctionCue,
    ...(template.focusAreas || []),
    ...(template.tags || []),
    ...(template.steps || []),
  ]
    .filter(Boolean)
    .join(' ')
    .toLowerCase();
}

export function matchesDrillFilter(template, filters = {}) {
  const { sport = '', level = 'all', search = '' } = filters;
  const normalizedSport = normalizeSportName(sport);
  const query = (search || '').trim().toLowerCase();

  if (normalizedSport && template.sport && template.sport !== normalizedSport) {
    return false;
  }

  if (level !== 'all' && template.level.length > 0 && !template.level.includes(level)) {
    return false;
  }

  if (query && !getTemplateSearchText(template).includes(query)) {
    return false;
  }

  return true;
}

export function groupDrillTemplates(templates, currentUserId, currentUserOrgId) {
  return (templates || []).reduce(
    (groups, template) => {
      if (template.sourceType === 'sas_kb') {
        groups.sas.push(template);
        return groups;
      }

      if (template.createdBy && template.createdBy === currentUserId) {
        groups.mine.push(template);
        return groups;
      }

      if (template.visibility === 'org' && template.orgId && template.orgId === currentUserOrgId) {
        groups.school.push(template);
        return groups;
      }

      return groups;
    },
    {
      sas: [],
      mine: [],
      school: [],
    }
  );
}

export function getBuiltInDrillTemplatesBySport(sport) {
  const normalizedSport = normalizeSportName(sport);

  return normalizeDrillTemplates(BUILT_IN_DRILL_TEMPLATES).filter(
    (item) => item.sport === normalizedSport
  );
}

export function toReviewDrill(template, currentUser, orgId) {
  const normalized = normalizeDrillTemplate(template, orgId);

  return {
    id: normalized.id,
    title: normalized.title,
    description: normalized.description,
    sport: normalized.sport,
    discipline: normalized.discipline,
    level: normalized.level,
    topic: normalized.topic,
    commonError: normalized.commonError,
    correctionCue: normalized.correctionCue,
    focusAreas: normalized.focusAreas,
    tags: normalized.tags,
    steps: normalized.steps,
    relatedSkillIds: normalized.relatedSkillIds,
    visibility: normalized.visibility,
    createdBy: normalized.createdBy || currentUser?.uid || '',
    orgId: normalized.orgId || orgId || '',
    sourceType: normalized.sourceType,
    sourceLabel: normalized.sourceLabel,
    addedBy: currentUser?.uid || '',
    addedAt: new Date().toISOString(),
  };
}
